import { Component } from '@angular/core';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { UtilsService } from 'src/app/services/utils.service';
import { NgxSpinnerService } from "ngx-spinner";
import { ClientService } from 'src/app/services/client.service';
import { ActivatedRoute, Router } from '@angular/router';

declare const $: any;
declare const google: any;

@Component({
    selector: 'app-client-edit',
    templateUrl: './client-edit.component.html',
    styleUrls: ['./client-edit.component.css']
})
export class ClientEditComponent {
    clientForm!: FormGroup
    submitted = false
    text_loading = "Espere un momento..."

    fiscalRegimes: any[] = []
    cfdiUses: any[] = []

    private idClient: number = 0;

    constructor(
        private fb: FormBuilder,
        private apiClient: ClientService,
        private utils: UtilsService,
        private spinner: NgxSpinnerService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        this.spinner.show()
        this.route.params.subscribe(params => {
            this.idClient = params["id"]
            this.getDataClient(params["id"])
        })
    }

    editOrigin = false
    editDestination = false
    indexOrigin: any = null
    indexDestination: any = null

    cologneAddressDestination: any = [];
    cologneAddressOrigin: any = [];

    forModelDestination = {
        street: null,
        number: null,
        postal_code: null,
        cologne: null,
        municipality: null,
        stated: null
    }

    forModelOrigin = {
        street: null,
        number: null,
        postal_code: null,
        cologne: null,
        municipality: null,
        stated: null
    }

    formModelData: any = {
        name: null,
        rfc: null,
        postal_code: null,
        fiscal_regime_id: null,
        cfdi_use_id: null,
        business_name: null,
        is_fiscal_address: false,
        fiscal_address: null,
        street: null,
        cologne: null,
        locality: null,
        municipality: null,
        state: null,
        country: null,
        exterior_number: null,
        interior_number: null,
        email: null,
        destination_address: [],
        origin_address: []
    }

    colognes: any = []

    geocoder: any;

    private getAddressComponent(components: any[], type: string): string {
        if (!Array.isArray(components)) return ''
        const found = components.find((c: any) => Array.isArray(c?.types) && c.types.includes(type))
        return found?.long_name || ''
    }

    onFiscalPlaceChanged(place: any) {
        const components = place?.address_components || []

        const route = this.getAddressComponent(components, 'route')
        const streetNumber = this.getAddressComponent(components, 'street_number')
        const subpremise = this.getAddressComponent(components, 'subpremise')

        const neighborhood = this.getAddressComponent(components, 'neighborhood')
        const sublocalityLevel1 = this.getAddressComponent(components, 'sublocality_level_1')
        const sublocality = this.getAddressComponent(components, 'sublocality')

        const locality = this.getAddressComponent(components, 'locality')
        const municipalityLevel2 = this.getAddressComponent(components, 'administrative_area_level_2')
        const municipalityLevel3 = this.getAddressComponent(components, 'administrative_area_level_3')
        const postalTown = this.getAddressComponent(components, 'postal_town')
        const municipality = municipalityLevel2 || municipalityLevel3 || postalTown || locality
        const state = this.getAddressComponent(components, 'administrative_area_level_1')
        const postalCode = this.getAddressComponent(components, 'postal_code')
        const country = this.getAddressComponent(components, 'country')

        const street = route
        const cologne = neighborhood || sublocalityLevel1 || sublocality

        this.formModelData.street = street || this.formModelData.street
        this.formModelData.exterior_number = streetNumber || this.formModelData.exterior_number
        this.formModelData.interior_number = subpremise || this.formModelData.interior_number
        this.formModelData.cologne = cologne || this.formModelData.cologne
        this.formModelData.locality = locality || this.formModelData.locality
        this.formModelData.municipality = municipality || this.formModelData.municipality
        this.formModelData.state = state || this.formModelData.state
        this.formModelData.postal_code = postalCode || this.formModelData.postal_code
        this.formModelData.country = country || this.formModelData.country

        if (this.clientForm) {
            this.clientForm.patchValue({
                street: this.formModelData.street || '',
                exterior_number: this.formModelData.exterior_number || '',
                interior_number: this.formModelData.interior_number || '',
                cologne: this.formModelData.cologne || '',
                locality: this.formModelData.locality || '',
                municipality: this.formModelData.municipality || '',
                state: this.formModelData.state || '',
                postal_code: this.formModelData.postal_code || '',
                country: this.formModelData.country || ''
            })
        }
    }

    getDataClient(id: any) {
        this.apiClient.getId(id).subscribe((resp) => {
            this.formModelData = resp
            this.spinner.hide()

            this.formModelData.is_fiscal_address = false

            if (this.clientForm) {
                this.clientForm.patchValue({
                    fiscal_regime_id: this.formModelData.fiscal_regime_id || '',
                    cfdi_use_id: this.formModelData.cfdi_use_id || '',
                    business_name: this.formModelData.business_name || '',
                    is_fiscal_address: this.formModelData.is_fiscal_address,
                    fiscal_address: this.formModelData.fiscal_address || '',
                    street: this.formModelData.street || '',
                    cologne: this.formModelData.cologne || '',
                    locality: this.formModelData.locality || '',
                    municipality: this.formModelData.municipality || '',
                    state: this.formModelData.state || '',
                    postal_code: this.formModelData.postal_code || '',
                    country: this.formModelData.country || '',
                    exterior_number: this.formModelData.exterior_number || '',
                    interior_number: this.formModelData.interior_number || '',
                })
                this.updateFiscalValidators(this.formModelData.is_fiscal_address)
            }
        })
    }

    ngOnInit(): void {

        this.clientForm = this.fb.group({
            name: ['', Validators.required],
            rfc: ['', Validators.required],
            fiscal_regime_id: ['', Validators.required],
            cfdi_use_id: ['', Validators.required],
            business_name: ['', Validators.required],
            is_fiscal_address: [false, Validators.required],
            fiscal_address: [''],
            street: [''],
            cologne: [''],
            locality: [''],
            municipality: [''],
            state: [''],
            postal_code: [''],
            country: [''],
            exterior_number: [''],
            interior_number: [''],
            email: ['', [Validators.required, Validators.email]]
        })

        this.loadCatalogs()

        this.clientForm.get('is_fiscal_address')?.valueChanges.subscribe((value: any) => {
            this.formModelData.is_fiscal_address = !!value
            this.updateFiscalValidators(!!value)
        })
        this.updateFiscalValidators(false)

        if (this.formModelData) {
            this.clientForm.patchValue({
                fiscal_regime_id: this.formModelData.fiscal_regime_id || '',
                cfdi_use_id: this.formModelData.cfdi_use_id || '',
                business_name: this.formModelData.business_name || '',
                is_fiscal_address: !!this.formModelData.is_fiscal_address,
                fiscal_address: this.formModelData.fiscal_address || '',
                street: this.formModelData.street || '',
                cologne: this.formModelData.cologne || '',
                locality: this.formModelData.locality || '',
                municipality: this.formModelData.municipality || '',
                state: this.formModelData.state || '',
                postal_code: this.formModelData.postal_code || '',
                country: this.formModelData.country || '',
                exterior_number: this.formModelData.exterior_number || '',
                interior_number: this.formModelData.interior_number || '',
            })
            this.updateFiscalValidators(!!this.formModelData.is_fiscal_address)
        }
    }

    loadCatalogs() {
        this.apiClient.getFiscalRegimes().subscribe((resp: any) => {
            this.fiscalRegimes = resp || []
        })
        this.apiClient.getCfdiUses().subscribe((resp: any) => {
            this.cfdiUses = resp || []
        })
    }

    updateFiscalValidators(isFiscalAddress: boolean) {
        const fiscalAddress = this.clientForm.get('fiscal_address')
        const street = this.clientForm.get('street')
        const cologne = this.clientForm.get('cologne')
        const locality = this.clientForm.get('locality')
        const municipality = this.clientForm.get('municipality')
        const state = this.clientForm.get('state')
        const postalCode = this.clientForm.get('postal_code')
        const country = this.clientForm.get('country')
        const exteriorNumber = this.clientForm.get('exterior_number')
        const interiorNumber = this.clientForm.get('interior_number')

        if (isFiscalAddress) {
            fiscalAddress?.clearValidators()

            street?.clearValidators()
            cologne?.clearValidators()
            locality?.clearValidators()
            municipality?.clearValidators()
            state?.clearValidators()
            postalCode?.clearValidators()
            country?.clearValidators()
            exteriorNumber?.clearValidators()
            interiorNumber?.clearValidators()
        } else {
            fiscalAddress?.clearValidators()

            street?.setValidators([Validators.required])
            cologne?.setValidators([Validators.required])
            locality?.setValidators([Validators.required])
            municipality?.setValidators([Validators.required])
            state?.setValidators([Validators.required])
            postalCode?.setValidators([Validators.required])
            country?.setValidators([Validators.required])
            exteriorNumber?.setValidators([Validators.required])
            interiorNumber?.setValidators([Validators.required])
        }

        fiscalAddress?.updateValueAndValidity()
        street?.updateValueAndValidity()
        cologne?.updateValueAndValidity()
        locality?.updateValueAndValidity()
        municipality?.updateValueAndValidity()
        state?.updateValueAndValidity()
        postalCode?.updateValueAndValidity()
        country?.updateValueAndValidity()
        exteriorNumber?.updateValueAndValidity()
        interiorNumber?.updateValueAndValidity()
    }

    onChangeSearch(val: any, type: any) {
        val = val.target.value
        this.geocoder = new google.maps.Geocoder();
        if (val.length >= 3) {
            this.spinner.show()
            this.text_loading = "Validando codigo postal"
                this.geocoder.geocode( { 'address': val}, (result:any, status:any) => {
                    this.spinner.hide()
                    if(status == 'OK'){

                        if (type == 2) {
                            this.forModelOrigin.cologne  = result[0].hasOwnProperty('postcode_localities') ? result[0].postcode_localities[0] : ''
                            this.forModelOrigin.municipality = result[0].address_components[1].long_name
                            this.forModelOrigin.stated = result[0].address_components[2].long_name
                        } else if (type == 3) {
                            this.forModelDestination.cologne  = result[0].hasOwnProperty('postcode_localities') ? result[0].postcode_localities[0] : ''
                            this.forModelDestination.municipality = result[0].address_components[1].long_name
                            this.forModelDestination.stated = result[0].address_components[2].long_name
                        }

                    }else{
                        alert("Ingrese un codigo postal valido")
                    }

                    
                });
            // this.apiClient.getPostal(val).subscribe((resp: any) => {
            //     if (resp.length > 0) {
            //         this.colognes = resp[0]
            //         if (type == 2) {
            //             this.cologneAddressOrigin = this.colognes.data
            //             this.forModelOrigin.stated = this.cologneAddressOrigin[0].stated
            //         } else if (type == 3) {
            //             this.cologneAddressDestination = this.colognes.data
            //             this.forModelDestination.stated = this.cologneAddressDestination[0].stated
            //         }
            //     } else {
            //         alert("Ingrese un codigo postal valido")
            //     }
            //     this.spinner.hide()
            // })
        }
    }

    get registerFormControl() {
        return this.clientForm.controls;
    }

    addAddressDestination() {
        if (this.editDestination) {
            this.formModelData.destination_address[this.indexDestination] = this.forModelDestination
        } else {
            this.formModelData.destination_address.push(this.forModelDestination)
        }

        $("#formDestination")[0].reset()
        this.resetForm();
        $("#addAddresDestination").modal("hide")
        this.editDestination = false
        this.cologneAddressDestination = []
    }
    editAddressDestination(index: number) {
        this.forModelDestination = this.formModelData.destination_address[index]
        this.editDestination = true
        this.indexDestination = index
        this.onChangeSearch({ target: { value: this.forModelDestination.postal_code } }, 3)
        $("#addAddresDestination").modal("show")
    }
    deleteAddressDestination(i: number) {
        this.formModelData.destination_address.splice(i, 1)
    }
    resetForm() {
        this.forModelDestination = {
            street: null,
            number: null,
            postal_code: null,
            cologne: null,
            municipality: null,
            stated: null
        }

        this.forModelOrigin = {
            street: null,
            number: null,
            postal_code: null,
            cologne: null,
            municipality: null,
            stated: null
        }
    }
    resetAllForm() {
        this.formModelData = {
            name: null,
            rfc: null,
            postal_code: null,
            fiscal_regime_id: null,
            cfdi_use_id: null,
            business_name: null,
            is_fiscal_address: false,
            fiscal_address: null,
            street: null,
            cologne: null,
            locality: null,
            municipality: null,
            state: null,
            country: null,
            exterior_number: null,
            interior_number: null,
            email: null,
            destination_address: [],
            origin_address: []
        }
    }

    addAddressOrigin() {
        if (this.editOrigin) {
            this.formModelData.origin_address[this.indexOrigin] = this.forModelOrigin
        } else {
            this.formModelData.origin_address.push(this.forModelOrigin)
        }

        $("#formAddOrigin")[0].reset()
        this.resetForm();
        $("#addAddresOrigin").modal("hide")
        this.editOrigin = false
        this.cologneAddressOrigin = []
    }
    editAddressOrigin(index: number) {
        this.forModelOrigin = this.formModelData.origin_address[index]
        this.indexOrigin = index
        this.editOrigin = true
        this.onChangeSearch({ target: { value: this.forModelOrigin.postal_code } }, 2)
        $("#addAddresOrigin").modal("show")
    }
    deleteAddressOrigin(i: number) {
        this.formModelData.origin_address.splice(i, 1)
        this.resetForm()
    }
    addClient() {
        if (this.clientForm.valid) {
            this.text_loading = "Actualizando Información..."
            this.spinner.show()
            this.apiClient.updateClient(this.formModelData, this.idClient).subscribe((resp: any) => {
                this.spinner.hide()
                this.utils.alertSwal({ text: resp.msg, icon: "success", title: "Actualización Exitosa." })
                    .then(() => this.router.navigate(['/client/list']))
            }, (error) => {
                this.utils.alertSwal({ text: "Se ha presentado un error al actualizar el cliente.", icon: "success", title: "Error." })
                this.spinner.hide()
            })
        }
    }
}
